import React, { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { AddPaymentApi } from '../../redux/payments/paymentApiCalls';
import { ShowPaymentContext, statusTypePayment } from './types';
import { Timeout } from '../../functions/functions';
import ButtonsForm from '../../HtmlComponents/ButtonsForm';
import { InputElement } from '../../HtmlComponents/InputElement';

interface props {
  modal: boolean,
  toggle: any
}

const AddPaymentModal: React.FC<props> = ({ modal, toggle }) => {
  const [loading, setLoading] = useState(false)
  const dispatch: any = useDispatch()
  const { setShowSuccessMsg, selectedPayment, subscriptionYear, note, setNote, statusType, setStatusType } = useContext(ShowPaymentContext)
  // const [listYear, setListYear] = useState("")
  
  const handleSubmit = async (e: any) => {
    e.preventDefault()
    try {
      setLoading(true)
      let response
      if(statusTypePayment.isDoctorSubscribedForYear === statusType) {
        response = await dispatch(AddPaymentApi({ subscriptionYear, note, doctor: selectedPayment.doctor?._id}))
      } else {
        response = await dispatch(AddPaymentApi({ subscriptionYear, doctor: selectedPayment.doctor?._id }))
        // response = await dispatch(AddPaymentApi({ subscriptionYear, listYear: listYear.split(","), doctor: selectedPayment.doctor?._id }))
      }
      if(response === true) {
        setShowSuccessMsg(true)
        setNote("")
        setStatusType("")
        setTimeout(() => setShowSuccessMsg(false), Timeout)
        toggle()
      } 
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      {modal && (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
              className="fixed inset-0 w-full h-full bg-black opacity-40"
              onClick={toggle}
            ></div>
            <div className="flex items-center min-h-screen px-4 py-8">
              <div className="relative w-full max-w-lg p-4 mx-auto bg-white rounded-md shadow-lg">
                <div className="mt-3">
                  {/* Start Modal Body */}
                  <form
                    className="mt-2 sm:ml-4 sm:text-left"
                    onSubmit={handleSubmit}
                  >
                    {statusTypePayment.isDoctorSubscribedForYear === statusType && 
                      <InputElement name='Donner une note' value={note} setValue={setNote}/>
                    }
                    {/* <InputElement name='Donner la liste' value={listYear} setValue={setListYear}/> */}
                    <ButtonsForm loading={loading} typeBtn='Ajouter' toggle={toggle} />
                  </form>
                  {/* End Modal Body */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default AddPaymentModal
